import React from "react";
import { flagCountries } from "../mock";

const Row = ({ reverse }) => (
  <div className="flex overflow-hidden">
    <div className={`flex gap-4 shrink-0 marquee-track animate-marquee ${reverse ? "[animation-direction:reverse]" : ""}`}>
      {[...flagCountries, ...flagCountries].map((c, i) => (
        <div key={`${c.code}-${i}`} className="flex items-center gap-2.5 bg-white rounded-xl border border-slate-100 card-shadow px-4 py-3 shrink-0">
          <img src={`https://flagcdn.com/w80/${c.code}.png`} alt={c.name} className="w-8 h-6 object-cover rounded shadow-sm" />
          <span className="text-sm font-medium text-slate-700 whitespace-nowrap">{c.name}</span>
        </div>
      ))}
    </div>
  </div>
);

export default function Countries() {
  return (
    <section id="countries" className="py-16 lg:py-20 bg-gradient-to-b from-teal-50/50 to-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900">Delivering Medicines Across <span className="text-teal-600">220+ Countries</span></h2>
          <p className="mt-3 text-slate-600">We offer express shipping and hassle-free customs clearance in major global destinations.</p>
        </div>
      </div>
      <div className="space-y-4">
        <Row />
        <Row reverse />
      </div>
    </section>
  );
}
